import Accordion from "@/common/components/Accordion"
import MaintenanceSpecificationsSection from "./MaintenanceSpecificationsSection";
import { MaintenanceSpecificationDirectiveKlass } from "@/features/establishmentLeadsFunnel/types/establishmentLead.type";
import MaintenanceGeneralInformationSection from "./MaintenanceGeneralInformationSection";
import { EstablishmentCompanyData } from "@/common/types/establishment/company.type";

interface AccreditationCMSectionProps {
  establishmentCompany: EstablishmentCompanyData;
  disabled?: boolean;
}

const AccreditationCMSection = ({
  establishmentCompany,
  disabled,
}: AccreditationCMSectionProps) => {
  return (
    <Accordion
      defaultOpen
      head="Dados para manutenção (CM)"
      className="p-0"
      triggerClassName="p-4 text-lg font-bold"
      bodyClassName="p-4 pt-0"
      body={(
        <div className="flex flex-col gap-4">
          <Accordion
            defaultOpen
            head="Diagnóstico e Orçamento"
            className="p-4"
            triggerClassName="px-0 py-1 text-[18px] font-bold"
            bodyClassName="pt-4 pb-0"
            body={(
              <MaintenanceSpecificationsSection
                establishmentCompany={establishmentCompany}
                directiveKlass={MaintenanceSpecificationDirectiveKlass.DiagnosticEntry}
                alertText={{
                  title: 'Tudo que for especificado será homologado para Diagnostico e Orçamento.',
                  description: 'Não adicione o que não é capaz de atender.',
                }}
                disabled={disabled}
              />
            )}
          />

          <Accordion
            defaultOpen
            head="Garantia de fábrica (Concessionária)"
            className="p-4"
            triggerClassName="px-0 py-1 text-[18px] font-bold"
            bodyClassName="pt-4 pb-0"
            body={(
              <MaintenanceSpecificationsSection
                establishmentCompany={establishmentCompany}
                directiveKlass={MaintenanceSpecificationDirectiveKlass.ScrapEntry}
                alertText={{
                  title: 'Tudo que for especificado será homologado para atendimento nos serviços de Garantia de fábrica.',
                  description: 'Não adicione o que não é capaz de atender.',
                }}
                disabled={disabled}
              />
            )}
          />

          <MaintenanceGeneralInformationSection
            establishmentCompany={establishmentCompany}
            disabled={disabled}
          />

          <MaintenanceSpecificationsSection
            establishmentCompany={establishmentCompany}
            directiveKlass={MaintenanceSpecificationDirectiveKlass.ExecutionEntry}
            alertText={{
              title: 'Tudo que for especificado será homologado para atendimento no CM.',
              description: 'Não adicione o que não é capaz de atender.',
            }}
            disabled={disabled}
          />
        </div>
      )}
    />
  )
}

export default AccreditationCMSection;
